import React from "react";
import { Category, DeviceFragment, LocationScope } from "generated/graphql";
import { DeviceHeader } from "../DeviceHeader";
import { AnalysisCharts } from "collections/AnalysisCharts/AnalysisCharts";

export const DeviceAnalysis: React.FC<{ device: DeviceFragment }> = ({
  device
}) => {
  return (
    <div className="device-analysis">
      <DeviceHeader
        device={device}
        pageTitle={
          <>
            {device?.hardwareModel}
            <p className="inline-block device-header-name">
              {` | ${device?.name || device?.room?.name || device?.macAddress}`}
            </p>
          </>
        }
      />
      <AnalysisCharts
        id={device.id}
        category={Category.Device}
        locationScope={LocationScope.Device}
      />
    </div>
  );
};
